module.exports = __webpack_public_path__ + "static/audio/new-order.6da31926314aef9bf7d6a4c6556bc498.mp3";